import React, {useEffect} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import {fetchDocumento} from '../../../../store/empresa';
import EmpresaDocumentoCreatePage from './_create';
import EmpresaDocumentoDetailPage from './_detail';
import EmpresaDocumentoEditPage from './_edit';

export default function EmpresaDocumentoPage() {
  const dispatch = useDispatchWithResult();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;

  useEffect(() => {
    dispatch(fetchDocumento({empresaId, id}));
  }, [empresaId, id]);

  return (
      <Switch>
        <Route path="/*/empresas/:empresaId/documentos/:id/edit" component={EmpresaDocumentoEditPage} />
        <Route path="/*/empresas/:empresaId/documentos/create" component={EmpresaDocumentoCreatePage} />
        <Route path="/*/empresas/:empresaId/documentos/:id" component={EmpresaDocumentoDetailPage} />
      </Switch>);
}
